var styles = {"switchRoot":"index-module_switchRoot__jFKiY","label":"index-module_label__acfV9","reverse":"index-module_reverse__ysXDE","disabled":"index-module_disabled__S4S8Y","switchThumb":"index-module_switchThumb__P-zf4","content":"index-module_content__m4HPF","spaced":"index-module_spaced__GEFR-","semibold":"index-module_semibold__rAV7m"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
